export const leadGenErrorMessageBM = "Terima kasih kerana memilih Berjaya Sompo Insurance. Kami tidak dapat memproses pembaharuan anda secara dalam talian buat masa ini. Sila lengkapkan borang di bawah, dan pihak kami akan menghubungi anda."

export const generalErrorMessageBM = "Kami tidak dapat meneruskan pembelian insurans anda kerana ia tidak memenuhi garis panduan pengunderaitan kami. Kami menghargai minat anda terhadap Berjaya Sompo Insurance."

// export const generalErrorMessageBM = `Maaf, kami tidak dapat meneruskan permintaan anda secara dalam talian. Sila hubungi Khidmat Pelanggan kami di 1 800 889 933 atau +603 2170 7300, waktu operasi 8.30 pagi - 5.00 petang (Isnin hingga Jumaat) tidak termasuk cuti umum. Anda juga boleh menghantar butiran kenderaan anda (plat nombor dan No. KP) melalui e-mel ke banca.support@bsompo.com.my untuk mendapat bantuan lanjut.`

export default [
  {
    apiError: "general",
    message: generalErrorMessageBM
  },
  {
    apiError: "Referred",
    message: leadGenErrorMessageBM
  },
  {
    apiError: "Decline",
    message: leadGenErrorMessageBM
  },
  // {
  //   apiError: "ISM Connectivity Error",
  //   message: generalErrorMessageBM
  // },
  // {
  //   apiError: "[INVALID PERMANENT POST CODE]",
  //   message: "Poskod tidak sah!"
  // },
  // {
  //   apiError: "UW Policy holder Age Referred",
  //   message: generalErrorMessageBM
  // },
  {
    apiError: "POLICY LAPSED DAYS SHOULD NOT BE MORE THAN 14 DAYS",
    message: generalErrorMessageBM
  },
  // {
  //   // TP to comprehensive
  //   apiError: "1 - Scope of Cover changed from Third Party to Comprehensive Referred $$UW Sum Insured Referred",
  //   message: generalErrorMessageBM
  // },
  // {
  //   apiError: "UW Sum Insured Referred",
  //   message: generalErrorMessageBM
  // },
  // {
  //   // a case of high perf vehicle got this error
  //   apiError: "MAKE MODEL MISSING",
  //   message: generalErrorMessageBM
  // },
  {
    apiError: "sessionExpired",
    message: "Sesi anda sudah tamat. Sila mula semula dari awal."
  },
  // {
  //   apiError: "InvalidOTP",
  //   message: "OTP anda tidak sah, sila cuba semula!"
  // },
  // {
  //   apiError: "missingDetail",
  //   message: "Sila pastikan anda telah mengisi maklumat peribadi dengan betul." 
  // },
  {
    apiError: "Error in IDNo1 or IDNo2 or ID not matches",
    message: "Ralat berlaku semasa mendapatkan maklumat anda. Sila pastikan anda telah mengisi Nombor Kad Pengenalan/Pasport dan Nombor Pendaftaran Kenderaan anda dengan betul."
  },
  {
    apiError: "Previous Policy Lapsed",
    message: "Kami tidak dapat memperbaharui insurans kereta anda secara dalam talian kerana polisi insurans anda telah luput lebih daripada 14 hari."
  },
  {
    apiError: "POLICY SHOULD BE LESS THAN 60 DAYS",
    message: "Permohonan pembelian anda tidak dapat diteruskan kerana polisi insurans anda hanya boleh diperbaharui dalam tempoh dua bulan sebelum tarikh tamat tempoh."
  },
  {
    apiError: "UW Make & Model Referred",
    message: "Kami tidak dapat memperbaharui insurans kereta anda secara dalam talian kerana model kenderaan anda tiada dalam senarai perlindungan kami. Terima kasih kerana meluangkan masa untuk mempertimbangkan Berjaya Sompo Insurance."
  },
  {
    apiError: "Pricing Field Error",
    message: "Ralat berlaku semasa mendapatkan maklumat anda."
  },
  // {
  //   apiError: "MULTIPLE NVIC RECEIVED",
  //   message: "Ralat berlaku semasa mendapatkan maklumat anda."
  // },  
  {
    apiError: "Number of Claim at Fault 2 Referred",
    message: "Kami tidak dapat memproses insurans kereta anda secara dalam talian kerana ID peribadi dan/atau kenderaan anda mempunyai 2 atau lebih tuntutan yang salah dalam tempoh 3 tahun yang lepas. Terima kasih kerana meluangkan masa untuk mempertimbangkan Berjaya Sompo Insurance."
  },
  // {
  //   apiError: "Wrong vehicle class",
  //   message: "Motorcycle"
  // },
  // {
  //   apiError: "SUM INSURED IS 0",
  //   message: "Ralat berlaku semasa mendapatkan maklumat anda."
  // },  
  // {
  //   apiError: "renewalNotFound",
  //   message: "Kami tidak menjumpai rekod anda bagi polisi tahun sebelumnya dengan kami. Untuk meneruskan, sila masukkan maklumat peribadi anda."
  // }
  {
    apiError: 'REQUEST LIMIT EXCEEDED',
    message: 'REQUEST LIMIT EXCEEDED'
  },
]